import { render, staticRenderFns } from "./ReqFSNsDetailed.vue?vue&type=template&id=4842dcc6&scoped=true"
import script from "./ReqFSNsDetailed.vue?vue&type=script&lang=js"
export * from "./ReqFSNsDetailed.vue?vue&type=script&lang=js"
import style0 from "./ReqFSNsDetailed.vue?vue&type=style&index=0&id=4842dcc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842dcc6",
  null
  
)

export default component.exports